export const colors = {
	light_blue: '#00B0E7',
	light_green: '#82C1A7',
	light_red: '#F17C7C',
	yellow: '#E7B400',
	green: 'green',
	red: 'red',
	black: '#212121',
	white: 'white',
	light_gray: '#707070',
	dropdown_scroll: '#6e6a6a',
	blue: '#2b07f7',
	green_hover: '#9ED3CD',
	primary_default: '#2162ac',
	purple: '#9B59B6',
};
